import { useQuery } from '@tanstack/react-query';

import { folderApi, TFolder, TFolderListOrder } from '@_entities/content';

import { FOLDER_QUERY_KEYS } from '../../model';

export function useFolderListQuery(order: TFolderListOrder) {
	return useQuery<TFolder[]>({
		queryKey: FOLDER_QUERY_KEYS.folderList(true, order),
		queryFn: async () => {
			const { data: folderList } = await folderApi.getFolderList(true, order);

			return folderList;
		},
		staleTime: 1000 * 60 * 60 * 6,
	});
}
